import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import VisionPage from "@/pages/VisionPage";
import JournalPage from "@/pages/JournalPage";
import FAQPage from "@/pages/FAQPage";
import CollectionsPage from "@/pages/CollectionsPage";
import { CartProvider } from "@/lib/cart";

function ScrollToTop() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);
  return null;
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/vision" element={<VisionPage />} />
            <Route path="/journal" element={<JournalPage />} />
            <Route path="/archive" element={<JournalPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/collections" element={<CollectionsPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid #2a2a2a",
              color: "#f5f5f0",
              borderRadius: "2px",
              fontFamily: "DM Sans, sans-serif",
              letterSpacing: "0.04em",
            },
          }}
        />
      </CartProvider>
    </div>
  );
}

export default App;
